import PropTypes from 'prop-types';
import { isBlank, isPresent } from 'utils/helperMethods';
import i18n from 'i18next';

import Presenter from 'utils/PropTypesPresenter';
import LoanOfficerPresenter from 'presenters/LoanOfficerPresenter';

export default new Presenter(
  {
    referralLink: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    slug: PropTypes.string,
    profileImageUrl: PropTypes.string,
    companyName: PropTypes.string,
    companyLogoUrl: PropTypes.string,
    activeFavoriteLoanOfficers: PropTypes.arrayOf(LoanOfficerPresenter.shape()),
  },
  {
    possessiveName(realEstateAgent) {
      const firstName = this.firstName(realEstateAgent);
      if (isBlank(firstName)) return `${i18n.t('models.App.userTypes.realEstateAgent')}'s`;

      return `${firstName}'s`;
    },
    fullName(realEstateAgent) {
      const fullName = `${this.firstName(realEstateAgent)} ${this.lastName(realEstateAgent)}`;
      return fullName.trim();
    },
    readableCompanyName(realEstateAgent) {
      const companyName = this.companyName(realEstateAgent);
      return isPresent(companyName) ? companyName : i18n.t('models.App.userTypes.realEstateAgent');
    },
  },
);



// WEBPACK FOOTER //
// ./src/presenters/RealEstateAgentPresenter.js